import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.storage.objectstore.create;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
	additionalSagas,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORAGE_OBJECTSTORE_CREATE',
	method: 'POST',
	url: '/storage/objectstore/create.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors, additionalSagas };
